// 320px-wide WebP: sharp at 2x for the 80px sign-in size, a fraction of the PNG.
import logo from "@69ly/ui/logo.webp";

/** The 69LY mark (69LY is the team that makes 69LY Companion). 36px high in headers, 80px on the sign-in page. */
export function Logo({ height = 36 }: { height?: number }) {
  return <img src={logo} alt="69LY Companion" height={height} width={Math.round((height * 640) / 344)} className="logo" />;
}
